import { PickersDay } from "@mui/x-date-pickers";
import "./customDay.scss";

const CustomDay = (props: any) => {
  const { day, shouldDisableDate } = props;
  const isDisabled = shouldDisableDate(day);
  return (
    <PickersDay {...props} className={!isDisabled ? "td-active-day" : ""} />
  );
};

export default CustomDay;
